// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"156":"7888489a","196":"e2157745"}[chunkId] + ".chunk.js";
};